// --- Modules
import Node, { payload } from './Node';

class Policy extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Policy'
    });
  }
};

export default {
  create: (opts) => {
    let item = new Policy(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
